<template>
    <div>
        <div class="modal hide fade" id="modalReviseMemo" tabindex="-1" role="dialog" aria-labelledby="modalReviseMemo" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="document">
              <div class="modal-content">
                  <div class="modal-header red darken-3 text-left text-white">
                      <h4 class="modal-title w-100 font-weight-bold">Revise Memo</h4>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                      </button>
                  </div>
                  <div class="modal-body">
                      <form>
                          <div class="form-group">
                              <label for="notes" class="col-form-label">Notes:</label>
                              <textarea v-model="notes" class="form-control" rows="5"/>
                          </div>
                      </form>
                  </div>
                  <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary" data-dismiss="modal" @click="process">Process</button>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'MemoInboxModal',
  data () {
    return {
      notes: null
    }
  },
  methods: {
    process: function () {
      var obj = {
        notes: this.notes
      }
      this.notes = null
      this.$emit('processRevise', obj)
    }
  }
}
</script>
